"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.zIndices=void 0;var zindexDropdown=1e3,zindexSticky=1020,zindexFixed=1030,zindexModalBackdrop=1040,zindexFinancialBar=1045,zindexModal=1050,zindexPopover=1060,zindexTooltip=1070,zindexPlanHeader=0,zindexPlanContent=-1,zindexAboveAuto=1,zIndices=[1000,// 0
zindexSticky,// 1
zindexFixed,// 2
zindexModalBackdrop,// 3
zindexModal,// 4
zindexPopover,// 5
zindexTooltip,// 6
zindexPlanHeader,// 7
zindexPlanContent,// 8
zindexAboveAuto,// 9
zindexFinancialBar// 10
];exports.zIndices=zIndices;